export default {
  view: "Image",
  image:
    "https://raw.githubusercontent.com/ambientstl/cave-game/master/images/map/cave-entrance.png"
};
